export const CSS = 96.0;
export const PDF = 72.0;
export const PDF_TO_CSS_UNITS = CSS / PDF;
